import React, { forwardRef } from 'react';
import { SvgIcon } from '@material-ui/core';

const CheckCircle = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="0 0 26.968 26.968" ref={ref} {...props}>
      <path d="M26.968 13.484A13.484 13.484 0 1113.484 0a13.484 13.484 0 0113.484 13.484zm-15.044 7.14l10-10a.87.87 0 000-1.23l-1.23-1.23a.87.87 0 00-1.23 0l-8.155 8.153L7.5 12.508a.87.87 0 00-1.23 0l-1.233 1.229a.87.87 0 000 1.23l5.655 5.655a.87.87 0 001.23 0z" />
    </SvgIcon>
  );
});

export default CheckCircle;
